module.exports = __webpack_public_path__ + "static/media/TableChipped_Before.461c7f58.jpg";